
import anime from 'animejs'
import { defineComponent } from 'vue'
export default defineComponent({
  mounted() {
    const { title, offer } = this.$refs
    const tl = anime.timeline({ loop: true, easing: 'easeInOutQuad', duration: 300 })
    tl.add({ targets: [title, offer], opacity: [0, 1], translateY: { value: [5, 0], easing: 'easeOutQuad' } }, '+=200')
    tl.add({ targets: [title, offer], opacity: 0 }, '+=2500')
  }
})
